import Immutable from 'immutable';
import * as types from '../actionTypes/docketsActionTypes';
import * as irSearchTypes from '../actionTypes/irSearchActionTypes';
import { createReducer } from '../utils';

const initialStateValue = {
  status: '',
  favoriteEmail: {
    status: 'loading',
    email: '',
  },
  favoriteEmails: {
    status: 'loading',
    emails: [],
    lastRecipients: [],
  },
  popup: {
    name: null,
    show: false,
    data: {},
  },
  docketParts: {
    step: 0,
    purchased: 0,
    partsToPurchase: 0,
    totalCost: 0,
    parts: 0,
    percentage: 0,
    status: 'loading',
    errors: null,
    alreadyPurchased: false,
  },
  selectedDocket: {
    status: null,
    seqNum: null,
    docket_no: null,
    binder: {
      // documents: [],
    },
  },
  documentsList: [],
  redact: {
    showFlash: false,
    seqNum: null,
    showPopup: false,
  },
  entries: {
    // empty | loading | error
    status: '',
    data: [],
  },
  receipt: {},
  header: {
    status: '',
  },
};

const initialState = Immutable.fromJS(initialStateValue);

export default createReducer(initialState, {
  [types.DOCKETS_POPUP]: (state, action) => {
    const { popup } = action;
    return state.merge({ popup });
  },
  [types.DOCKETS_FAVORITE_EMAIL]: (state, action) => {
    const { favoriteEmail } = action;
    return state.mergeDeep({ favoriteEmail });
  },
  [types.DOCKETS_FAVORITE_EMAILS]: (state, action) => {
    const { favoriteEmails } = action;
    return state.set('favoriteEmails', { ...state.get('favoriteEmails'), ...favoriteEmails });
  },
  [types.UPDATE_DOCKETS_PARTS]: (state, action) => {
    const { docketParts } = action;
    return state.mergeDeep({ docketParts });
  },
  [types.RESET_DOCKETS_PARTS]: state => {
    const { docketParts } = initialStateValue;
    return state.merge({ docketParts });
  },
  [types.UPDATE_DOCKET_HEADER]: (state, action) => {
    const { docketHeader } = action;
    return state.mergeDeep({ docketHeader });
  },
  [irSearchTypes.REQUEST_DOCKET_PARTS]: (state, action) => {
    const step = action.step || 1;
    const pdfZip = { status: 'loading', step };
    return initialState.mergeDeep({ pdfZip });
  },
  [irSearchTypes.RECEIVE_DOCKET_PARTS]: (state, action) => {
    const pdfZip = { ...action.data, isLoading: false };
    return state.mergeDeep({ pdfZip });
  },
  [types.UPDATE_REDACT]: (state, action) => {
    const { redact } = action;
    return state.mergeDeep({ redact });
  },
  [types.FETCH_DOCUMENTS.REQUEST]: (state, { selectedDocket }) =>
    state.set('selectedDocket', initialState.get('selectedDocket').merge(selectedDocket)),

  [types.FETCH_DOCUMENTS.ERROR]: (state, { selectedDocket }) =>
    state.getIn(['selectedDocket', 'docket_seq']) === selectedDocket.docket_seq
      ? state.set('selectedDocket', initialState.get('selectedDocket').merge(selectedDocket))
      : state,

  [types.FETCH_DOCUMENTS.SUCCESS]: (state, { selectedDocket }) => {
    const docketIndex = state
      .getIn(['entries', 'data'])
      .findIndex(doc => doc.get('docket_seq') === selectedDocket.docket_seq);

    const updatedDocket =
      docketIndex >= 0
        ? state.getIn(['entries', 'data', docketIndex]).merge({ ...selectedDocket })
        : Immutable.fromJS(selectedDocket);

    if (state.getIn(['selectedDocket', 'docket_seq']) === selectedDocket.docket_seq) {
      return state.set('selectedDocket', updatedDocket).setIn(['entries', 'data', docketIndex], updatedDocket);
    }

    return state.setIn(['entries', 'data', docketIndex], updatedDocket);
  },

  [types.UPDATE_DOCUMENT]: (state, { seqNum, document }) => {
    const docketIndex = state.getIn(['entries', 'data']).findIndex(doc => doc.get('docket_seq') === seqNum);
    const previousDocket = state.getIn(['entries', 'data', docketIndex]);
    const documentIndex = previousDocket
      .getIn(['binder', 'documents'])
      .findIndex(doc => doc.get('number') === document.number);
    const updatedDocket = previousDocket.mergeIn(['binder', 'documents', documentIndex], Immutable.fromJS(document));

    if (state.getIn(['selectedDocket', 'docket_seq']) === seqNum) {
      return state.set('selectedDocket', updatedDocket).setIn(['entries', 'data', docketIndex], updatedDocket);
    }

    return state.setIn(['entries', 'data', docketIndex], updatedDocket);
  },
  [types.UPDATE_SELECTED_DOCKET]: (state, { selectedDocket }) =>
    state.set('selectedDocket', Immutable.fromJS(selectedDocket)),
  [types.UPDATE_DOCKETS]: (state, action) => {
    // note we don't want mergeDeep here because it will "merge" any new array data, instead of replacing them
    return state.merge({ ...action });
  },
  [types.SET_RECEIPT]: (state, { receipt }) => state.set('receipt', Immutable.fromJS(receipt)),
  SERVICE_ERROR: (state, action) => state.mergeDeep({ data_ready: true, error: action.errors }),
});



// WEBPACK FOOTER //
// ./src/redux/reducers/docketReducer.js